import React, { Component } from 'react';

export default class Progress extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="1.jpg upper">
        <div className="captions">Промежуточная аттестация</div>
        <div className="table-mark">
          <div className="table-mark__years">
            <div className="table-mark__years_item active-item">2017-2018</div>
            <div className="table-mark__years_item">2016-2017</div>
            <div className="table-mark__years_item">2015-2016</div>
            <div className="table-mark__years_item">2014-2015</div>
          </div>
          <table>
            <tr>
              <th>Дисциплина</th>
              <th>Отчетность</th>
              <th>Оценка</th>
              <th>Дата</th>
              <th>Преподаватель</th>
              <th>Пересдача</th>
            </tr>
            <tr>
              <td colSpan="6" className="semestr">1 семестр</td>
            </tr>
            <tr>
              <td className="align-left">История государства и права</td>
              <td>экзамен</td>
              <td>отлично</td>
              <td>03.01.2018</td>
              <td>Самойлов И. Г.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Психологическое сопровождение в экстремальных условиях</td>
              <td>экзамен</td>
              <td>хорошо</td>
              <td>05.01.2018</td>
              <td>Петросян А. П.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Социология</td>
              <td>экзамен</td>
              <td>удовл.</td>
              <td>08.01.2018</td>
              <td>Семипядьев К. Н.</td>
              <td>●</td>
            </tr>
            <tr>
              <td className="align-left">Психология в педагогике</td>
              <td>диф.зачет</td>
              <td>зачет</td>
              <td>12.01.2018</td>
              <td>Лонских Л. Р.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Физподготовка<br /></td>
              <td>экзамен</td>
              <td>хорошо</td>
              <td>15.01.2018</td>
              <td>Бурляев А. В.</td>
              <td />
            </tr>
            <tr>
              <td colSpan="6" className="semestr">2 семестр</td>
            </tr>
            <tr>
              <td className="align-left">История военного дела</td>
              <td>экзамен</td>
              <td>отлично</td>
              <td>15.06.2018</td>
              <td>Полуэктов В. Д.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Общая педагогика</td>
              <td>экзамен</td>
              <td>отлично</td>
              <td>17.06.2018</td>
              <td>Сергеев С. С.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Теория и методика профессионального образования</td>
              <td>диф.зачет</td>
              <td>зачет</td>
              <td>21.06.2018</td>
              <td>Прошутинская К. Н.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Методология предметного образования</td>
              <td>экзамен</td>
              <td>отлично</td>
              <td>25.06.2018</td>
              <td>Сверлов В. Д.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Информатизация образования</td>
              <td>диф.зачет</td>
              <td>хорошо</td>
              <td>27.06.2018</td>
              <td>Бесконтактных З. Г.</td>
              <td />
            </tr>
            <tr>
              <td className="align-left">Разработка информационной среды управления</td>
              <td>экзамен</td>
              <td>отлично</td>
              <td>29.06.2018</td>
              <td>Полевая П. Р.</td>
              <td />
            </tr>
          </table>
        </div>
      </div>

    );
  }
}

